module.exports = __webpack_public_path__ + "static/media/IMG_0140.2bbee7d2.webp";